import { BrowserModule } from '@angular/platform-browser';

import { CommonModule, registerLocaleData } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import ptBr from '@angular/common/locales/pt';
import {
  DEFAULT_CURRENCY_CODE,
  LOCALE_ID,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
registerLocaleData(ptBr);

import { MatSidenavModule } from '@angular/material/sidenav';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha-2';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AlertsModule } from './alerts/alerts.module';
import { FooterComponent } from './components/footer/footer.component';
import { InstallmentsDropdownDrawerComponent } from './components/installments-dropdown-workspace/installments-dropdown-drawer/installments-dropdown-drawer.component';
import { UserMenuDrawerComponent } from './features/logged-area/layouts/user-menu/user-menu-drawer.component';
import { LoadingComponent } from './components/loading/loading.component';
import { ToasterComponent } from './components/toaster/toaster.component';
import { appInitialize } from './configuration/app-initiator';
import { DataDogService } from './configuration/datadog/services/data-dog.service';
import { DataServiceService } from './configuration/services/data-service.service';
import { TokenCleanupService } from './configuration/services/token-cleanup.service';
import { environment } from './environments/environments';
import { SerasaPremiumComponent } from './features/logged-area/recurrence/components/serasa-premium.component';
import { httpInterceptorProviders } from './helpers';
import { FeatureFlagsFacadeService } from './services/feature-flags-facade.service';
import { Effects, Reducers } from './store';
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    NgxMaskDirective,
    NgxMaskPipe,
    CommonModule,
    ToasterComponent,
    LoadingComponent,
    AlertsModule,
    BrowserModule,
    AppRoutingModule,
    MatSidenavModule,
    InstallmentsDropdownDrawerComponent,
    UserMenuDrawerComponent,
    BrowserAnimationsModule,
    RecaptchaV3Module,
    StoreModule.forRoot(Reducers),
    StoreDevtoolsModule.instrument({ maxAge: 25, logOnly: environment.production }),
    EffectsModule.forRoot(Effects),
    FooterComponent,
    SerasaPremiumComponent,
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'pt' },
    { provide: DEFAULT_CURRENCY_CODE, useValue: 'BRL' },
    provideAppInitializer(() => {
      const initializerFn = appInitialize(
        inject(TokenCleanupService),
        inject(DataServiceService),
        inject(DataDogService),
        inject(FeatureFlagsFacadeService)
      );
      return initializerFn();
    }),
    httpInterceptorProviders,
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recapchaSiteKey,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideNgxMask(),
  ],
})
export class AppModule {}
